import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import { featureFlagRequests } from "@/api/(requests)/featureFlagTyped";

import * as actionTypes from "./actionTypes";

let privateInterval = undefined;
let _publicInterval = undefined;

const flagsLoaded = (flags) => {
  return {
    type: actionTypes.FLAGS_LOADED,
    ...flags,
  };
};

const flagIntervalReset = (flags) => {
  return {
    flags: { ...flags },
    type: actionTypes.CLEAR_FLAG_INTERVALS,
  };
};

export const loadFlags = () => async (dispatch) => {
  getFeatureFlagsPub()
    .then((transformedConfigs) => {
      dispatch(flagsLoaded({ publicFlags: transformedConfigs }));
    })
    .catch((e) => {
      console.log(e);
      const defaultFlags = PUBLIC_FEATURE_FLAG_DEFAULTS;

      console.log("Error retrieving feature flags, using defaults", defaultFlags);
      dispatch(flagsLoaded({ publicFlags: defaultFlags }));
    });

  _publicInterval = setInterval(async () => {
    if (document.hidden) {
      console.log("Document is currently hidden. Waiting to fetch public feature flags.");

      return;
    }
    getFeatureFlagsPub().then((transformedConfigs) => {
      dispatch(flagsLoaded({ publicFlags: transformedConfigs }));
    });
  }, 300000);
};

export const loadTargetedFlags = () => async (dispatch) => {
  getFeatureFlagsPrivate()
    .then((transformedConfigs) => {
      dispatch(flagsLoaded({ privateFlags: transformedConfigs }));
    })
    .catch((e) => {
      console.log(e);
      const defaultFlags = PRIVATE_FEATURE_FLAG_DEFAULTS;

      console.log("Error retrieving feature flags, using defaults", defaultFlags);
      dispatch(flagsLoaded({ privateFlags: defaultFlags }));
    });

  privateInterval = setInterval(async () => {
    if (document.hidden) {
      console.log("Document is currently hidden. Waiting to fetch private feature flags.");

      return;
    }
    getFeatureFlagsPrivate().then((transformedConfigs) => {
      dispatch(flagsLoaded({ privateFlags: transformedConfigs }));
    });
  }, 300000);
};

export const clearFlagInterval = () => async (dispatch) => {
  clearInterval(privateInterval);
  clearInterval(_publicInterval);
  dispatch(flagIntervalReset());
};

const getFeatureFlagsPub = async () => {
  return featureFlagRequests.get_feature_flag_set({ body: { flag_set: "WEB_PUBLIC_FLAG_NAMES" } });
};

const getFeatureFlagsPrivate = async () => {
  return featureFlagRequests.get_all_targetted_feature_flags({
    body: { flag_set: "WEB_PRIVATE_FLAG_NAMES" },
  });
};

/**
 *
 * !!! Remember to update defaults when adding or removing feature flags or updating
 * WEB_PRIVATE_FLAG_NAMES and WEB_PUBLIC_FLAG_NAMES.
 *
 */

const PUBLIC_FEATURE_FLAG_DEFAULTS = {
  [FeatureFlagEnum.insuranceEligibilityCheck]: true,
  [FeatureFlagEnum.recaptchaOverride]: false,
};

const PRIVATE_FEATURE_FLAG_DEFAULTS = {
  [FeatureFlagEnum.acuityOverride]: false,
  [FeatureFlagEnum.manualPaymentProcessing]: false,
  [FeatureFlagEnum.restrictPatientScheduling]: true,
  [FeatureFlagEnum.updatedCalendarNps]: true,
};
